import { Component, OnInit } from '@angular/core';
import { ApicallService } from '../../services/apicall.service';
import { Router, ActivatedRoute, Params, RoutesRecognized } from '@angular/router';
import { FlashService } from '../../services/flash.service';
import { NavTitleService } from '../../services/nav-title.service';
import { Subscription } from 'rxjs';
import { IdleTimerService } from '../../services/idletimer.service';
import { HostListener } from '@angular/core';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  title: string;
  subscription: Subscription;
  page = '';

  constructor(
    public apiCallService:ApicallService,
    private router:Router,
    private flashService: FlashService,
    private route: ActivatedRoute,
    private data: NavTitleService,
    private idleTimerService: IdleTimerService
  ) { 
    router.events.subscribe(val => {
      if (val instanceof RoutesRecognized) {
        if(val.state.root.firstChild.data.title !== undefined){
          this.title = val.state.root.firstChild.data.title;
        }else{
          this.title = '';
        }
      }
    });
  }

  ngOnInit() {
    if(this.apiCallService.loggedIn()){
      this.idleTimerService.startInactivityTimer();
    }
    this.data.currentTitle.subscribe(title => {
       this.title = title
    });
  }

  onLogoutClick(){
    this.apiCallService.logout();
    this.flashService.show("Logout Successfully.", 5000, 'success');
    this.router.navigate(['/']);
    this.apiCallService.destryeeSession('Geekay').subscribe(data=>{
    })
    return false;
  }

  @HostListener('document:mousemove', ['$event'])
  @HostListener('document:keydown', ['$event'])
  resetInactivityTimer(event: Event): void {
    if(this.apiCallService.loggedIn()){  
      this.idleTimerService.resetInactivityTimer();
    }
  }
}
